/**
 * src/lib/utils/base64.js — bytes -> base64 in the browser.
 *
 * Chunked: `String.fromCharCode(...bytes)` on a large buffer overflows the call
 * stack (TICKET-1217: a ~600 KB invoice PDF threw RangeError before any request).
 *
 * @tested-by tests/lib/api/cfo-upload-invoice.test.js
 */
export function bytesToBase64(bytes) {
  let binary = '';
  const CHUNK = 0x8000;
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
}
